module.exports = __webpack_public_path__ + "img/60.3d84a58e.jpg";